import { Component, Inject } from '@angular/core';
import { cmsActions } from '@src/store/reducers/cmsReducer';
import * as _str from 'underscore.string';
import { Store } from '@src/store';

@Component({
    selector: 'jira-cms-manager',
    template: require('./jira-cms-manager.component.html')
})
export class JiraCmsManagerComponent {
   public projectId:any;

    constructor(private store: Store , @Inject('$stateParams') $stateParams: any){
      this.projectId = $stateParams.id
      this.store.dispatch({ type: cmsActions.GET_ALL_JIRA_CMS_TASKS_QUERYS, payload: { projectId: this.projectId } });
     
  }

  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/jiraCMSManager-ang7/jira-cms-manager.component.ts